import i18n from "config/i18next";

i18n.addResources("es", "global", {
  goToSave: "Ir a guardar",
  notSave: "No quiero guardarlos",
  understood: "Entendido",
  export: "Exportar",
  cancel: "Cancelar",
  edit: "Modificar",
  save: "Guardar",
  accept: "Aceptar",
  create: "Crear",
  createConfirmation: "Sí, crear",
  saveChanges: "Guardar cambios",
  restore: "Restablecer",
  finish: "Finalizar",
  email: "Email",
  noResults: "No obtuvimos resultados para tu búsqueda :(",
  search: "Buscar",
  back: "Volver",
  seeMore: "Ver más",
  seeLess: "Ver menos",
  date: "día / mes / año",
  confirm: "Confirmar",
  continue: "Continuar",
  checkErrors: "Revisar errores",
  filter: "Filtros",
  update: "Actualizar",
  updateConfirmation: "Sí, actualizar",
  saveError: "No se van a guardar tus cambios",
  allF: "Todas",
  allM: "Todos",
  disabled: "Deshabilitado",
  enabled: "Habilitado",
  replace: "Reemplazar",
  delete: "Eliminar",
  deleteConfirmation: "Sí, eliminar",
  download: "Descargar",
  upload: "Cargar archivo",
  state: "Estado",
  close: "Cerrar",

  monday: "Lunes",
  tuesday: "Martes",
  wednesday: "Miércoles",
  thursday: "Jueves",
  friday: "Viernes",
  saturday: "Sábado",
  sunday: "Domingo",

  mondayShort: "Lun",
  tuesdayShort: "Mar",
  wednesdayShort: "Mié",
  thursdayShort: "Jue",
  fridayShort: "Vie",
  saturdayShort: "Sáb",
  sundayShort: "Dom",
});

i18n.addResources("es", "alerts", {
  saveChangesTitle: "Guardá tus cambios",
  saveChangesMessage:
    "Si te vas sin guardar, tus cambios no van a quedar registrados.",
  withoutSavingTitle: "No se van a guardar tus archivos",
  withoutSavingMessage:
    "Hay errores en la carga. Si te vas sin resolverlos, no se van a guardar los cambios.",
  exportTitle: "Exportaste exitosamente",
  exportMessage: "El archivo se descargó correctamente",
  connectionErrorTitle: "Error de conexión",
  connectionErrorMessage:
    "Hubo un error de comunicación con el servidor. Por favor, intentalo nuevamente",
  serverErrorTitle: "Error en nuestro servidor",
  serverErrorMessage: "Por favor, reintentalo nuevamente.",
  changesSavedTitle: "Datos guardados",
  changesSavedMessage: "Ya quedaron registrados los cambios",
  changesWillBeLostMessage: "Tus cambios no van a quedar registrados",
});

i18n.addResources("es", "validations", {
  required: "Este campo es requerido",
  specialCharacters: "No se admiten caracteres especiales",
  numbersOrSpecialCharacters: "No se admiten números o caracteres especiales",
  invalidFormat: "El formato es inválido",
  enterValidFormat: "Ingresá el formato correcto",
  invalidEmailFormat: "El correo ingresado es inválido",
  positiveNumber: "El número debe ser mayor a cero",
  numbersOnly: "Solo se admiten caracteres numéricos",
  afterNow: "El horario debe ser posterior al actual",
  maxDate: "El rango no puede superar los {{data}} días",
  initialGreaterThanEnd: "Ingresar un horario posterior a la hora de comienzo",
});
